import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { VoiceService } from '@voice/services/VoiceService';
import ItemForm from '@pbx/components/stats/detailed/modal-export-detailed-form';
import i18n from '@app/plugins/i18n';

class ExportModalService extends ModalService {
  constructor() {
    super(VoiceService);
  }

  create() {
    return this.$open({
      title: i18n.t('shared.component.modal.create_recording'),
      width: this.size.default_plus,
      loading: true,
      render: h =>
        h(ItemForm, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new ExportModalService();
export { instance as ExportModalService };
